const PERMISOS = (state, permisos) => {
    state.permisos = permisos;
};



export default {
    PERMISOS,
};